"use strict";

/*
  `navigator.geolocation` is unintuitive, so here's how Chrome behaves:

  - `getCurrentPosition()` and `watchPosition()` events are fired at the same time
  - The browser only fires a location event when:
    - `navigator.geolocation` is called for the first time after the page loads
    - The user's location changes

  This means that only the first call to `getCurrentPosition()` or `watchPosition()` after the page loads will get a location, subsequent calls have to wait for the location to change (which might not happen for minutes if the user isn't moving).

  The solution is to ALWAYS pass a `{ maximumAge: Infinity }` parameter so the browser will return the last known location.
*/
const Geolocation = function () {
  const locationOptions = {
    enableHighAccuracy: true,
  };
  const currentPositionTimeoutMs = 5 * 1000;

  var start = function () {
    if (!Session.isMobileParentView()) {
      navigator.geolocation.watchPosition(updateMarker, handleWatchError, {
        ...locationOptions,
        maximumAge: Infinity,
      });
    }
  };

  var getCurrentLatLng = function () {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(
        (position) => resolve(updateMarker(position)),
        (error) => fallbackToLastWatchedLocation(resolve, reject, error.code),
        {
          ...locationOptions,
          timeout: currentPositionTimeoutMs,
        },
      );
    });
  };

  var fallbackToLastWatchedLocation = function (resolve, reject, errorCode) {
    const lastWatchedLocation = Tree.get("blueDotLatLng");

    // See all error codes at https://developer.mozilla.org/en-US/docs/Web/API/GeolocationPositionError
    // Code 3 = TIMEOUT
    if (errorCode === 3 && lastWatchedLocation) {
      resolve(lastWatchedLocation);
      return;
    }

    reject(errorCode);
  };

  var updateMarker = function (pos) {
    const latLng = {
      lat: pos.coords.latitude,
      lng: pos.coords.longitude,
    };

    Tree.set("blueDotLatLng", latLng);

    return latLng;
  };

  var handleWatchError = function (e) {
    console.warn("Geolocation error (" + e.code + ") " + e.message);
  };

  return {
    start,
    getCurrentLatLng,
  };
};

module.exports = Geolocation();

const Session = require("../login/session");
const Tree = require("../tree");
